<template>
  <div>
    <template v-if="loading && messageList.length === 0">
      <img class="gif-loading" :src="`https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/130/gif_loading.gif`" />
      <div class="title">正在努力加载中...</div>
    </template>
    <template v-else>
    <div v-if="messageList.length">
      <div
        class="message-list"
        v-for="(item, index) in messageList"
        :key="index"
      >
        <img class="photos" :src="item.sendSourcePicture" />
        <div class="message-list-item">
          <div class="send">
            <div class="send-name">{{ item.sendSourceName }}</div>
            <div class="send-date">{{ item.createTime.slice(0, 10) }}</div>
          </div>
          <div class="send-content">{{ item.sendContent }}</div>
          <div
            class="send-delete"
            v-if="item.canDelete === 1"
            @click="deleteMessage(item)"
          >
            <i
              class="el-icon-error"
              :style="{
                'font-size': $px2rem(`${26}px`),
                'margin-right': $px2rem(`${6}px`),
              }"
            ></i
            >删除
          </div>
        </div>
      </div>
      <div
        :style="{
          'padding-top': $px2rem(`${43}px`),
          'padding-bottom': $px2rem(`${76}px`),
        }"
      >
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="total"
          @current-change="curChange"
          :current-page="pageNo"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <none-data></none-data>
    </div>
    </template>
    <el-dialog
      :visible.sync="DialogVisible"
      center
    >
      <div slot="title">
        <div class="dialog-title">温馨提示</div>
      </div>
      <div class="dialog-content">是否确认删除？</div>
      <span slot="footer" class="dialog-footer">
        <div class="cancel-btn" @click="DialogVisible = false">取消</div>
        <div class="ensure-btn" @click="enSure">确认</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { delLeaveMessage, getLeaveMessage } from "@/api/request";
import NoneData from "@/pages/components/none-data.vue";
export default {
  props: {
    id: [String, Number],
  },
  components: { NoneData },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      loading: false,
      messageList: [],
      total: 0,
      DialogVisible: false,
    };
  },
  created() {
    this.getLeaveMessages();
  },
  methods: {
    getLeaveMessages() {
      this.loading = true
      getLeaveMessage({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        memberId: this.id,
        bizType: 3,
      }).then((res) => {
        this.loading = false
        this.messageList = res.data.result.records;
        this.total = Number(res.data.result.total);
      });
    },
    deleteMessage(item) {
      this.DialogVisible = true;
      this.delId = item.id;
    },
    enSure() {
      delLeaveMessage({ id: this.delId }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.DialogVisible = false;
          this.getLeaveMessages();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    curChange(e) {
      this.pageNo = e;
      this.getLeaveMessages();
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #579487;
  color: #fff;
}
</style>
<style lang="scss" scoped>
:deep .el-dialog {
  border-radius: 10px;
  width: 366px;
}
.dialog-content {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #323232;
}
.dialog-title {
  font-size: 20px;
  color: #323232;
  font-weight: 600;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .cancel-btn {
    width: 144px;
    background: #f4f5f7;
    line-height: 48px;
    font-size: 17px;
    color: #45796e;
    border-radius: 8px;
    margin-right: 18px;
  }
  .ensure-btn {
    width: 144px;
    background: #45796e;
    line-height: 48px;
    font-size: 17px;
    color: #ffffff;
    border-radius: 8px;
  }
}
.gif-loading{
  width: 384px;
  height: 196px;
}
.message-list {
  display: flex;
  padding: 20px 0;
  border-bottom: 1px solid #e9e9e9;
  .photos {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  &-item {
    width: 100%;
    margin-left: 14px;
    font-size: 16px;
    .send {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .send-name {
        color: #323232;
        font-weight: 600;
        font-size: 18px;
        margin-right: 14px;
      }
      .send-date {
        font-size: 16px;
        color: #8a8a8a;
      }
    }
    .send-content {
      font-size: 14px;
      color: #323232;
      text-align: left;
      line-height: 25px;
      cursor: pointer;
    }
    .send-delete {
      color: #8a8a8a;
      cursor: pointer;
      text-align: right;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: end;
    }
    .send-delete:hover {
      color: #fd0808;
    }
  }
}
</style>
